import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import BubbleBox from '@components/Common/BubbleBox';
import { RootState } from '@Redux/detail/store';
import { Flag, Info } from '@components/Common/Icons';
import { Link } from 'react-scroll';
import styles from '../style.module.scss';
import { useMediaQuery } from 'react-responsive';
import { LightBox } from '@lion-design/core';

const Place = () => {
    const { GroupInfo, StationInfoList } = useSelector((store: RootState) => store.groupReducer);
    const [isAssembleOpen, setIsAssembleOpen] = useState<boolean>(false);

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const bubbleContent = '若出發地與集合地為不同地點，交通方式請參閱產品頁詳細說明！';

    return StationInfoList.length > 0 ? (
        <div className={cN(styles['group-trip-info'], styles.place, 'group_trip_info', 'place')}>
            <div className={styles.title}>出發集合地點</div>
            <div className={styles.content}>
                <ul className={styles.dep}>
                    <li className={styles['sub-title']}>出發地點</li>
                    <li className={styles['contents-list']}>
                        {GroupInfo.StartFromCityList.map((data, idx) => (
                            <span key={idx}>{data.CityName}</span>
                        ))}
                    </li>
                </ul>
                <ul className={styles.add}>
                    <li className={styles['sub-title']}>集合地點</li>
                    <li className={styles['contents-list']}>
                        <div className={styles.place}>
                            {StationInfoList.map((data, idx) => (
                                <span key={idx}>{data.Place}</span>
                            ))}
                        </div>
                        <span className={styles.tips}>
                            {isMobile ? (
                                <span
                                    className={styles.icon}
                                    onClick={() => setIsAssembleOpen(true)}
                                >
                                    集合說明
                                    <Info fill="#999" />
                                </span>
                            ) : (
                                <BubbleBox content={bubbleContent} bubbleWidth={316}>
                                    集合說明
                                    <Info fill="#999" />
                                </BubbleBox>
                            )}
                        </span>
                    </li>
                </ul>
            </div>
            <Link className={styles.btns} to="assemble" smooth={true} duration={500}>
                <Flag fill="#222" />
                集合地點詳情
            </Link>
            {/* 光箱 */}
            <LightBox
                className="assemble"
                open={isAssembleOpen}
                ToggleLightBox={() => setIsAssembleOpen(false)}
            >
                {bubbleContent}
            </LightBox>
        </div>
    ) : null;
};

export default Place;
